import React, { useEffect, useState } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import Header from './common/Header/Header';
import Maintenance from '../common/components/Maintenance/Maintenance';
import styles from './IndexPage.module.less';
import { getMultipleMessages } from './service';
import STATUS_CODE from '../../request/statusCode';
import { isLogin } from '../../utils/login';

const IndexPage = () => {
  const [message, setMessage] = useState([]);

  useEffect(() => {
    getMultipleMessages().then(res => {
      if (
        res.statusCode === STATUS_CODE.OK &&
        res.data &&
        res.data.length > 0
      ) {
        const messages = res.data.map(item => item.message);
        setMessage(messages);
      }
    });
  }, []);

  return (
    <div className={styles.IndexPage}>
      <Header />
      <Maintenance message={message} />
      <Switch>{isLogin() && <Redirect from='/login' to='/portal' />}</Switch>
    </div>
  );
};

export default IndexPage;
